export default __webpack_public_path__ + "static/media/banner_exp.b46ed5b7.jpg";